<template>
  <div class="px-2 lg:px-4 py-2">
    <div id="top"></div>
    <PBreadcrumb :parts="parts" current-page-label="Version du site" />
    <div class="flex flex-col gap-2 py-6 lg:px-16">
      <h1 class="text-h1 font-bold">Version du site</h1>
      <p v-if="config.tchapLink">
        Toutes les informations sur les montées en version sont disponibles sur notre
        <PLink class="inline-flex!" :to="config.tchapLink">canal Tchap</PLink>
      </p>
      <VersionAnnouncement />
      <a
        href="#top"
        class="self-end border-b pb-0.25 active:bg-grey-975 hover:border-b-[3px] outline-primary-active outline-offset-4 cursor-pointer text-primary"
      >
        <OhVueIcon :name="upIcon" class="mr-1" />
        <span>Haut de page</span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PBreadcrumb, useConfig, useIcons, PLink } from "@pasta/box-v2";
import { type ParapheurConfig } from "../types";
import { RiArrowUpFill } from "oh-vue-icons/icons";
import { OhVueIcon } from "oh-vue-icons";
import VersionAnnouncement from "../../version-announcement/version-announcement.vue";
import { useIsLastVersionsSeen } from "../../version-announcement/use-is-last-version-seen.composable";
import { useVersionAnnouncementStore } from "../../version-announcement/version-announcement.store";
import { useUserPreferencesStore } from "../stores/user-preferences.store";
import { onMounted } from "vue";

const parts = [{ label: "Accueil", to: "/" }];

const config = useConfig<ParapheurConfig>();
const isLastVersionSeen = useIsLastVersionsSeen();
const userPreferencesStore = useUserPreferencesStore();
const versionsStore = useVersionAnnouncementStore();
const [upIcon] = useIcons(RiArrowUpFill);

onMounted(async () => {
  if (!isLastVersionSeen.value) {
    await userPreferencesStore.updateMine({
      lastSeenVersion: versionsStore.highestVersion!.id,
    });
  }
});
</script>
